import { useEffect } from "react";

import { useGetLoggedIn }     from "_common/hooks/auth";
import { useSetLoginPopup }   from "_common/hooks/global";
import { initialValidations } from "_common/ssrWrapper";
import Dashboard              from "_components/pages/growthDashboard/growthPageHome";

const component = () => {
	const isLoggedIn    = useGetLoggedIn ();
	const setLoginPopup = useSetLoginPopup ();

	useEffect ( () => {
		if ( isLoggedIn )
			return;

		setLoginPopup ( true );
	}, [ isLoggedIn ] );

	return (
		<Dashboard />
	);
};

const getServerSideProps = context => initialValidations ( context, async defaultProps => {
	/* context.res.setHeader (
    "Cache-Control",
    "public, s-maxage=10, stale-while-revalidate=59"
  ); */

	return {
		props: {
			...defaultProps
		}
	};

} );

export { getServerSideProps };

export default component;
